import { render, staticRenderFns } from "./editFbpClaims.vue?vue&type=template&id=f3ad2c66&scoped=true"
import script from "./editFbpClaims.vue?vue&type=script&lang=js"
export * from "./editFbpClaims.vue?vue&type=script&lang=js"
import style0 from "./editFbpClaims.vue?vue&type=style&index=0&id=f3ad2c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ad2c66",
  null
  
)

export default component.exports